/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCloneFragmentDetailMutationRequest, WebAppCloneFragmentDetailMutationResponse, WebAppCloneFragmentDetailPathParams } from "../models/WebAppCloneFragmentDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCloneFragmentDetail } from "../axios/webAppCloneFragmentDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCloneFragmentDetailMutationKey = () => [{ url: '/web-app/v1/fragments/:id/clone' }] as const

export type WebAppCloneFragmentDetailMutationKey = ReturnType<typeof webAppCloneFragmentDetailMutationKey>

export function webAppCloneFragmentDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCloneFragmentDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCloneFragmentDetailMutationKey()
        return mutationOptions<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return webAppCloneFragmentDetail(id, data, config)
          },
        })

}

/**
 * @summary Clone a fragment
 * {@link /web-app/v1/fragments/:id/clone}
 */
export function useWebAppCloneFragmentDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCloneFragmentDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCloneFragmentDetailMutationKey()

          const baseOptions = webAppCloneFragmentDetailMutationOptions(config) as UseMutationOptions<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest}, TContext>
          

          return useMutation<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCloneFragmentDetailMutationResponse, ResponseErrorConfig<Error>, {id: WebAppCloneFragmentDetailPathParams["id"], data: WebAppCloneFragmentDetailMutationRequest}, TContext>
      
}